export default {
  'menu.dashboard.workplace': '工作台',
  'workplace.welcome': '欢迎回来，',
  'workplace.docs': '帮助文档',
  'workplace.announcement': '公告',
  'workplace.record.nodata': '暂无数据',
  'workplace.quick.operation': '快捷操作',
  'workplace.quickOperation.setup': '管理',
  'workplace.loadMore': '加载更多',
  'workplace.viewMore': '查看更多',
  'workplace.pecs': '个',
  'workplace.item': '条',

  // 星悦媄
  'workplace.todayFollowUp': '今日待回访',
  'workplace.todayClient': '今日客资',
  'workplace.followUpData': '7日回访数据',
  'workplace.myTotalClient': '我的总客户',
};
